import { render, staticRenderFns } from "./RecommendedModal.vue?vue&type=template&id=8c3736f4&scoped=true&"
import script from "./RecommendedModal.vue?vue&type=script&lang=js&"
export * from "./RecommendedModal.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedModal.vue?vue&type=style&index=0&id=8c3736f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3736f4",
  null
  
)

export default component.exports